export default "__VITE_ASSET__DvNAncSp__"